import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { AnwendungsSelectorModule } from '../components/anwendungs-selector/anwendungs-selector.module';
import { ArticleScanAutocompleteModule } from '../components/article-scan-autocomplete/article-scan-autocomplete.module';
import { ComponentsModule } from '../components/components.module';
import { DiagnoseSelectorModule } from '../components/diagnose-selector/diagnose-selector.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { TierartSelectorModule } from '../components/tierart-selector/tierart-selector.module';
import { DialogsModule } from '../dialogs/dialogs.module';
import { BestandComponent, BookLossDialog, CorrectStockDialog, TransferStockDialog } from './bestand/bestand.component';
import { ChargeService } from './charges/charge.service';
import { ChargesComponent } from './charges/charges.component';
import { CreateChargeDialogComponent } from './charges/create-charge-dialog/create-charge-dialog.component';
import { EditChargeDialogComponent } from './charges/edit-charge-dialog/edit-charge-dialog.component';
import { CorrectAmountDialogComponent } from './goods-receipt-history/correct-amount-dialog/correct-amount-dialog.component';
import { CorrectOrderDialogComponent } from './goods-receipt-history/correct-order-dialog/correct-order-dialog.component';
import { GoodsReceiptHistoryComponent } from './goods-receipt-history/goods-receipt-history.component';
import { ReturnDeliveryDialogComponent } from './goods-receipt-history/return-delivery-dialog/return-delivery-dialog.component';
import { GoodsReceiptAddArticleComponent } from './goods-receipt/goods-receipt-add-article/goods-receipt-add-article.component';
import { GoodsReceiptComponent } from './goods-receipt/goods-receipt.component';
import { InventurModule } from './inventur/inventur.module';
import { ArtikelAnwendungDialogComponent } from './material/artikel-anwendung/artikel-anwendung-dialog/artikel-anwendung-dialog.component';
import { ArtikelAnwendungComponent } from './material/artikel-anwendung/artikel-anwendung.component';
import { ArtikelExcelImportDialogComponent } from './material/artikel-excel-import/artikel-excel-import-dialog/artikel-excel-import-dialog.component';
import { ArtikelExcelImportPreviewDialogComponent } from './material/artikel-excel-import/artikel-excel-import-preview-dialog/artikel-excel-import-preview-dialog.component';
import { AddIndikationToMaterialDialogComponent } from './material/artikel-indikation/add-indikation-to-material-dialog/add-indikation-to-material-dialog.component';
import { ArtikelIndikationComponent } from './material/artikel-indikation/artikel-indikation.component';
import { AddTierartToArticleDialogComponent } from './material/artikel-tierart/add-tierart-to-article-dialog/add-tierart-to-article-dialog.component';
import { ArtikelTierartComponent } from './material/artikel-tierart/artikel-tierart.component';
import { MaterialDetailsComponent } from './material/material-details/material-details.component';
import { ArtikelLagerHistorieDialogComponent } from './material/artikel-lager-historie-dialog/artikel-lager-historie-dialog.component';
import { MaterialHistorieDialogComponent } from './material/material-historie-dialog/material-historie-dialog.component';
import { MaterialPricesComponent } from './material/material-prices/material-prices.component';
import { MaterialPricesService } from './material/material-prices/material-prices.service';
import { MaterialWartezeitComponent } from './material/material-wartezeit/material-wartezeit.component';
import { WartezeitSonderfallDialogComponent } from './material/material-wartezeit/wartezeit-sonderfall-dialog/wartezeit-sonderfall-dialog.component';
import { MaterialComponent } from './material/material.component';
import { MaterialService } from './material/material.service';
import { RabattStaffelComponent } from './material/rabatt-staffel/rabatt-staffel.component';
import { RabattStaffelService } from './material/rabatt-staffel/rabatt-staffel.service';

import { SonderpreisDialogComponent } from './material/sonderpreis-dialog/sonderpreis-dialog.component';
import { StuecklisteComponent } from './material/stueckliste/stueckliste.component';
import { AddVetStockDialogComponent } from './stock/add-vet-stock-dialog/add-vet-stock-dialog.component';
import { StockService } from './stock/stock.service';
import { AddStoragePlaceDialogComponent } from './storage-place/add-storage-place-dialog/add-storage-place-dialog.component';
import { EditStoragePlaceDialogComponent } from './storage-place/edit-storage-place-dialog/edit-storage-place-dialog.component';
import { StoragePlaceComponent } from './storage-place/storage-place.component';
import { StoragePlaceService } from './storage-place/storage-place.service';
import { StorageComponent } from './storage/storage.component';
import { AddSupplierMaterialComponent } from './supplier-material/add-supplier-material/add-supplier-material.component';
import { SupplierHistorieDialogComponent } from './supplier-material/supplier-historie-dialog/supplier-historie-dialog.component';
import { SupplierMaterialSelectorComponent } from './supplier-material/supplier-material-selector/supplier-material-selector.component';
import { SupplierMaterialComponent } from './supplier-material/supplier-material.component';
import { SupplierMaterialService } from './supplier-material/supplier-material.service';
import { SupplierDetailsComponent } from './supplier/supplier-details/supplier-details.component';
import { LieferantDokumentFeldMappingDialogComponent } from './supplier/lieferant-dokument-feld-mapping-dialog/lieferant-dokument-feld-mapping-dialog.component';
import { SupplierComponent } from './supplier/supplier.component';
import { SupplierService } from './supplier/supplier.service';
import { TierarztBestandComponent } from './tierarzt-bestand/tierarzt-bestand.component';

import { WarehouseRoutingModule } from './warehouse-routing.module';
import { WarehouseComponent } from './warehouse.component';
import { LieferantenLayoutComponent } from './lieferanten-layout/lieferanten-layout.component';
import { InstitutionenComponent } from '../finanzen/institutionen/institutionen.component';
import { InstitutionDialogComponent } from '../finanzen/institutionen/institution-dialog/institution-dialog.component';
import { SonstigeDebitorenComponent } from '../finanzen/sonstige-debitoren/sonstige-debitoren.component';
import { SonstigerDebitorDialogComponent } from '../finanzen/sonstige-debitoren/sonstiger-debitor-dialog/sonstiger-debitor-dialog.component';
import { CreateRuecklieferungDialogComponent } from './warenruecklieferungen/create-ruecklieferung-dialog/create-ruecklieferung-dialog.component';
import { WarenruecklieferungenComponent } from './warenruecklieferungen/warenruecklieferungen.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
    declarations: [
        WarehouseComponent,
        LieferantenLayoutComponent,
        InstitutionenComponent,
        InstitutionDialogComponent,
        SonstigeDebitorenComponent,
        SonstigerDebitorDialogComponent,
        ChargesComponent,
        GoodsReceiptComponent,
        GoodsReceiptHistoryComponent,
        CorrectAmountDialogComponent,
        CorrectOrderDialogComponent,
        MaterialComponent,
        ArtikelAnwendungComponent,
        ArtikelAnwendungDialogComponent,
        ArtikelIndikationComponent,
        AddIndikationToMaterialDialogComponent,
        ArtikelTierartComponent,
        AddTierartToArticleDialogComponent,
        MaterialDetailsComponent,
        MaterialPricesComponent,
        RabattStaffelComponent,
        SupplierComponent,
        SupplierDetailsComponent,
        LieferantDokumentFeldMappingDialogComponent,
        StorageComponent,
        StoragePlaceComponent,
        TransferStockDialog,
        BookLossDialog,
        CorrectStockDialog,
        SupplierMaterialComponent,
        AddSupplierMaterialComponent,
        SupplierMaterialSelectorComponent,
        AddStoragePlaceDialogComponent,
        EditStoragePlaceDialogComponent,
        AddVetStockDialogComponent,
        BestandComponent,
        TierarztBestandComponent,
        StuecklisteComponent,
        CreateChargeDialogComponent,
        SonderpreisDialogComponent,
        MaterialWartezeitComponent,
        WartezeitSonderfallDialogComponent,
        ReturnDeliveryDialogComponent,
        WarenruecklieferungenComponent,
        CreateRuecklieferungDialogComponent,
        GoodsReceiptAddArticleComponent,
        EditChargeDialogComponent,
        ArtikelExcelImportDialogComponent,
        ArtikelExcelImportPreviewDialogComponent,
        SupplierHistorieDialogComponent,
        MaterialHistorieDialogComponent,
        ArtikelLagerHistorieDialogComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatPaginatorModule,
        MatRadioModule,
        MatDividerModule,
        KieneAutocompleteModule,
        KieneTableModule,
        WarehouseRoutingModule,
        MatSlideToggleModule,
        AnwendungsSelectorModule,
        DiagnoseSelectorModule,
        TierartSelectorModule,
        ArticleScanAutocompleteModule,
        DialogsModule,
        DragDropModule,
        InventurModule,
        ComponentsModule,
        DirectivesModule,
        MatTooltipModule,
        PdfViewerModule,
    ],
    exports: [
        TierarztBestandComponent,
        BestandComponent,
        BookLossDialog,
        CorrectStockDialog,
        TransferStockDialog,
        SupplierMaterialSelectorComponent,
        StuecklisteComponent,
    ],
    providers: [
        ChargeService,
        MaterialService,
        MaterialPricesService,
        RabattStaffelService,
        StockService,
        StoragePlaceService,
        SupplierService,
        SupplierMaterialService,
    ],
})
export class WarehouseModule {}
